<template>
    <div>
        <!-- 面包屑导航 -->
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item>系统消息</el-breadcrumb-item>
        </el-breadcrumb>
        <!-- 搜索筛选 -->
        <el-form :inline="true" :model="formInline" class="user-search">
            <el-form-item label="搜索：">
                <el-input size="small" v-model="formInline.title" placeholder="系统消息标题"></el-input>
            </el-form-item>
            <el-form-item label="">
                <el-input size="small" v-model="formInline.content" placeholder="系统消息内容"></el-input>
            </el-form-item>
            <el-form-item label="通道：">
                <el-select size="small" v-model="formInline.channel_type" placeholder="请选择">
                    <el-option selected label="请选择" value="0"></el-option>
                    <el-option label="锦胜雾森" value="jsws"></el-option>
                    <el-option label="凌阳高空" value="lygk"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item>
                <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
                <el-button size="small" type="primary" icon="el-icon-plus" @click="handleEdit()">添加</el-button>
            </el-form-item>
        </el-form>
        <!--列表-->
        <el-table size="small" @selection-change="selectChange" :data="listData" highlight-current-row
                  v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;">
            <el-table-column align="center" type="selection" width="60"></el-table-column>
            <el-table-column prop="id" label="ID" width="60"></el-table-column>
            <el-table-column prop="title" label="标题"></el-table-column>
            <el-table-column prop="channel_type" label="所属通道" width="100">
                <template slot-scope="scope">
                    <div>{{scope.row.channel_type == 'jsws' ? '锦胜雾森' : '凌阳高空'}}</div>
                </template>
            </el-table-column>
            <el-table-column prop="content" label="内容" show-overflow-tooltip>
                <template slot-scope="scope">
                    <div style="height: 30px;" v-html="scope.row.content"></div>
                </template>
            </el-table-column>
            <el-table-column sortable prop="created_at" label="创建时间" width="150">
            </el-table-column>
            <el-table-column align="center" label="操作" width="150">
                <template slot-scope="scope">
                    <el-button size="mini" @click="handleEdit(scope.row)">编辑</el-button>
                    <el-button size="mini" type="danger" @click="deleteNotice(scope.row)">删除</el-button>
                </template>
            </el-table-column>
        </el-table>
        <!-- 分页组件 -->
        <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
        <!-- 编辑界面 -->
        <el-dialog :title="title" :visible.sync="editFormVisible" width="70%" @click="closeDialog">
            <el-form label-width="120px" :model="editForm" :rules="rules" ref="editForm">
                <el-form-item label="标题" prop="title">
                    <el-input size="small" v-model="editForm.title" auto-complete="off" placeholder="标题"></el-input>
                </el-form-item>
                <el-form-item label="内容" prop="content">
                    <quill-editor ref="text" v-model="editForm.content" class="myQuillEditor" :options="editorOption"/>
                </el-form-item>
                <el-form-item label="所属通道" prop="channel_type">
                    <el-radio v-model="editForm.channel_type" label="jsws">锦胜雾森</el-radio>
                    <el-radio v-model="editForm.channel_type" label="lygk">凌阳高空</el-radio>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button size="small" @click="closeDialog">取消</el-button>
                <el-button size="small" type="primary" :loading="loading" class="title" @click="submitForm('editForm')">
                    保存
                </el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import {notice, noticeDelete, noticeSave} from '../../api/userMG'
    import Pagination from '../../components/Pagination'
    import Quill from 'quill'
    import {quillEditor} from 'vue-quill-editor'
    import 'quill/dist/quill.core.css'
    import 'quill/dist/quill.snow.css'
    import 'quill/dist/quill.bubble.css'
    import {ImageExtend} from 'quill-image-extend-module'

    Quill.register('modules/ImageExtend', ImageExtend)

    export default {
        data() {
            return {
                nshow: true, //switch开启
                fshow: false, //switch关闭
                loading: false, //是显示加载
                editFormVisible: false, //控制编辑页面显示与隐藏
                title: '添加',
                channel: 'jsws',
                editForm: {
                    id: '',
                    title: '',
                    content: '',
                    channel_type: 'jsws',
                },
                // rules表单验证
                rules: {
                    permissionName: [
                        {required: true, message: '请输入权限名称', trigger: 'blur'}
                    ],
                    permission: [
                        {required: true, message: '请输入权限CODE', trigger: 'blur'}
                    ]
                },
                editorOption: {
                    modules: {
                        ImageExtend: {
                            // 如果不作设置，即{}  则依然开启复制粘贴功能且以base64插入
                            name: "file", // 图片参数名
                            size: 3, // 可选参数 图片大小，单位为M，1M = 1024kb
                            action: "/res/imgUpload", // 服务器地址, 如果action为空，则采用base64插入图片
                            // response 为一个函数用来获取服务器返回的具体图片地址
                            // 例如服务器返回{code: 200; data:{ url: 'baidu.com'}}
                            // 则 return res.data.url
                            response: res => {
                                return res.data;
                            },
                            headers: xhr => {
                                // 上传图片请求需要携带token的 在xhr.setRequestHeader中设置
                                xhr.setRequestHeader(
                                    "Authorization",
                                    this.getCookie("username")
                                        ? this.getCookie("username").token_type +
                                        this.getCookie("username").access_token
                                        : "Basic emh4eTp6aHh5"
                                );
                            }, // 可选参数 设置请求头部
                            sizeError: () => {
                            }, // 图片超过大小的回调
                            start: () => {
                            }, // 可选参数 自定义开始上传触发事件
                            end: () => {
                            }, // 可选参数 自定义上传结束触发的事件，无论成功或者失败
                            error: () => {
                            }, // 可选参数 上传失败触发的事件
                            success: () => {
                            }, // 可选参数  上传成功触发的事件
                            change: (xhr, formData) => {
                                // xhr.setRequestHeader('myHeader','myValue')
                                // formData.append('token', 'myToken')
                            } // 可选参数 每次选择图片触发，也可用来设置头部，但比headers多了一个参数，可设置formData
                        },
                        toolbar: {
                            container: [
                                ['bold', 'italic', 'underline', 'strike'],        //加粗，斜体，下划线，删除线
                                ['blockquote', 'code-block'],         //引用，代码块
                                [{'header': 1}, {'header': 2}],               // 标题，键值对的形式；1、2表示字体大小
                                [{'list': 'ordered'}, {'list': 'bullet'}],          //列表
                                [{'script': 'sub'}, {'script': 'super'}],      // 上下标
                                [{'indent': '-1'}, {'indent': '+1'}],          // 缩进
                                [{'direction': 'rtl'}],                         // 文本方向
                                [{'size': ['small', false, 'large', 'huge']}],  // 字体大小
                                [{'header': [1, 2, 3, 4, 5, 6, false]}],         //几级标题
                                [{'color': []}, {'background': []}],          // 字体颜色，字体背景颜色
                                [{'font': []}],         //字体
                                [{'align': []}],        //对齐方式
                                ['clean'],        //清除字体样式
                                ['image', 'video']        //上传图片、上传视频
                            ]
                        }
                    },
                },
                formInline: {
                    page: 1,
                    limit: 10,
                    pageSize: 10,
                    title: '',
                    content: '',
                    channel_type: ''
                },
                // 选择数据
                selectdata: [],
                userparm: [], //搜索权限
                listData: [], //用户数据
                quillImg: false,
                addRange: [],
                // 分页参数
                pageparm: {
                    currentPage: 1,
                    pageSize: 10,
                    total: 10
                }
            }
        },
        // 注册组件
        components: {
            Pagination,
            quillEditor
        },
        /**
         * 数据发生改变
         */

        watch: {},

        /**
         * 创建完毕
         */

        mounted() {
            this.$refs.text.quill.getModule("toolbar").addHandler("image", this.imgHandler)
        },
        created() {
            this.loading = true
            this.getdata(this.formInline)
        },

        /**
         * 里面的方法只有被调用才会执行
         */

        methods: {
            // 获取数据方法
            getdata(parameter) {
                // 模拟数据
                this.loading = false
                notice(parameter).then(res => {
                    this.listData = res.items
                    this.loading = false
                    this.pageparm.currentPage = this.formInline.page
                    this.pageparm.pageSize = this.formInline.limit
                    this.pageparm.total = res.pageInfo.total
                })

            },
            // 分页插件事件
            callFather(parm) {
                this.formInline.page = parm.currentPage
                this.formInline.limit = parm.pageSize
                this.getdata(this.formInline)
            },
            // 搜索事件
            search() {
                this.getdata(this.formInline)
            },
            //显示编辑界面
            handleEdit: function (row) {
                this.editFormVisible = true
                if (row != undefined && row != 'undefined') {
                    // 深拷贝并赋值
                    this.editForm = row
                    this.title = '修改'
                    this.editForm.id = row.id
                    this.editForm.title = row.title
                    this.editForm.content = row.content
                    this.editForm.channel_type = row.channel_type
                } else {
                    this.title = '添加'
                    this.editForm.title = ''
                    this.editForm.content = ''
                    this.editForm.channel_type = 'jsws'
                }
            },
            // 编辑、增加页面保存方法
            submitForm(editData) {
                this.$refs[editData].validate(valid => {
                    if (valid) {
                        noticeSave(this.editForm)
                            .then(res => {
                                this.editFormVisible = false
                                this.loading = false
                                if (res.code == 200) {
                                    this.getdata(this.formInline)
                                    this.$message({
                                        type: 'success',
                                        message: '系统消息保存成功！'
                                    })
                                } else {
                                    this.$message({
                                        type: 'info',
                                        message: '保存失败'
                                    })
                                }
                            })
                            .catch(err => {
                                this.editFormVisible = false
                                this.loading = false
                                this.$message.error('系统消息保存失败，请稍后再试！')
                            })
                    } else {
                        return false
                    }
                })
            },
            // 关闭编辑、增加弹出框
            closeDialog() {
                this.editFormVisible = false
            },
            deleteNotice(row) {
                this.$confirm('确定要删除吗?', '信息', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    noticeDelete({ids: [row.id]})
                        .then(res => {
                            if (res.code == 200) {
                                this.$message({
                                    type: 'success',
                                    message: '系统消息已删除!'
                                })
                                this.getdata(this.formInline)
                            } else {
                                this.$message({
                                    type: 'info',
                                    message: '系统消息删除失败!'
                                })
                            }
                        })
                        .catch(err => {
                            this.loading = false
                            this.$message.error('系统消息删除失败，请稍后再试！')
                        })
                })
                    .catch(() => {
                        this.$message({
                            type: 'info',
                            message: '已取消删除'
                        })
                    })
            },
            imgHandler(state) {
                this.quillImg = true
                this.addRange = this.$refs.text.quill.getSelection()
                if (state) {
                    let fileInput = this.$refs.addImg
                    console.log(fileInput)
                    fileInput.click()
                }
            },
        }
    }
</script>

<style scoped>
    .user-search {
        margin-top: 20px;
    }
</style>



// WEBPACK FOOTER //
// src/views/notice/index.vue